import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerCardNetworkProperties from './PrimerCardNetworkProperties.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Group summary='Properties' closed mdxType="Group">
    <Item title='items' subtitle='[PrimerCardNetwork]' label='Required' mdxType="Item">
        <Group title='Element' mdxType="Group">
            <Item title='cardNetwork' subtitle='PrimerCardNetwork' mdxType="Item">
                Represents a card network and includes metadata about that network relative to
                a specific card BIN.
                <PrimerCardNetworkProperties mdxType="PrimerCardNetworkProperties" />
            </Item>
        </Group>
    </Item>
    <Item title='preferred' subtitle='PrimerCardNetwork?' mdxType="Item">
        The preferred card network. Use this to pre-select a network if there are multiple.
        <PrimerCardNetworkProperties mdxType="PrimerCardNetworkProperties" /> 
    </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      